import { ViewPhotoState } from '@/enums/viewEnums.ts';
import { WebSocketMessage } from '@/providers/WebSocketProvider/WebSocketProvider.tsx';
import { useWebSocketStore } from '@/store/useWebSocketStore.ts';
import { useProfileStore } from '@/store/useProfileStore.ts';

export const handleVideoApproved = (ctxData: WebSocketMessage) => {
  const { setLastEvents } = useWebSocketStore.getState();
  const { updateVideo } = useProfileStore.getState();

  if (ctxData.video_approved_event?.video_hid) {
    updateVideo(ctxData.video_approved_event.video_hid, ViewPhotoState.APPROVE);
    setLastEvents({
      videoStateChange: { video_hid: ctxData.video_approved_event.video_hid }
    });
  }
};
